import { render } from "./AddNoteAction.vue?vue&type=template&id=e4361178&scoped=true"
import script from "./AddNoteAction.vue?vue&type=script&lang=js"
export * from "./AddNoteAction.vue?vue&type=script&lang=js"

import "./AddNoteAction.vue?vue&type=style&index=0&id=e4361178&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4361178"]])

export default __exports__